import axios from 'axios'

export const baseUrl = new URL('https://api.avishash.com') // https://api.avishash.com https://internalavishash.azurewebsites.net https://localhost:49153/

export const clientConfig = {
  timeout: 60000,
  headers: { 
    'Content-Type': 'application/json',
  },
}

export const httpClient = axios.create(clientConfig)